export const CUSTOMER_DATA_FETCH = 'moi/customer/CUSTOMER_DATA_FETCH';
export const CUSTOMER_DATA_FETCH_SUCCESS = 'moi/customer/CUSTOMER_DATA_FETCH_SUCCESS';
export const CUSTOMER_DATA_UPDATE = 'moi/customer/CUSTOMER_DATA_UPDATE';
export const CUSTOMER_DATA_UPDATE_FINISHED = 'moi/customer/CUSTOMER_DATA_UPDATE_FINISHED';
